export const handwritingSamples = [
  [" ", " "],
  ["Practice makes perfect", "Keep writing every day"],
  ["Hello World!", "React is awesome"],
  ["Stay curious", "Keep learning"],
  ["Believe in yourself", "You can do it"],
  ["Never give up", "Push through the pain"],
  ["Creativity takes courage", "Art is freedom"],
  ["Write with passion", "Draw with purpose"],
  ["Dream big", "Start small"],
  ["Consistency is key", "Progress not perfection"],
  ["Explore new ideas", "Challenge the norm"],
  ["Handwriting is art", "Make it beautiful"]
];
